import { QqModel } from "../model/qq.model";

export const CHECKBOX_CHANGED_ACTION = "qq::checkbox::changed";
export const DROPDOWN_CHANGED_ACTION = "qq::dropdown::changed";
export const SLIDER_CHANGED_ACTION = "qq::slider::changed";
export const RESET_ACTION = "qq::system::reset";

export type QqActionData = {
  qq: QqModel;
  checked?: boolean;
  position?: number;
  selection?: string;
};

export type QqActionType = {
  type: string;
  data: QqActionData;
};
